import React, { useMemo } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Select de días de la semana reutilizable
const WeekdaySelect = React.memo(({
    value,
    onChange,
    label,
    disabled = false,
    size = 'medium',
    fullWidth = true
}) => {
    const { t } = useTranslation();

    const weekdays = useMemo(() => [
        { value: 'monday', label: t('settings.zones.fields.week_days.monday') },
        { value: 'tuesday', label: t('settings.zones.fields.week_days.tuesday') },
        { value: 'wednesday', label: t('settings.zones.fields.week_days.wednesday') },
        { value: 'thursday', label: t('settings.zones.fields.week_days.thursday') },
        { value: 'friday', label: t('settings.zones.fields.week_days.friday') },
        { value: 'saturday', label: t('settings.zones.fields.week_days.saturday') },
        { value: 'sunday', label: t('settings.zones.fields.week_days.sunday') }
    ], [t]);

    return (
        <FormControl fullWidth={fullWidth} disabled={disabled} size={size}>
            <InputLabel id={`weekday-select-${label}`}>{label}</InputLabel>
            <Select
                labelId={`weekday-select-${label}`}
                value={value}
                label={label}
                onChange={onChange}
            >
                {weekdays.map(({ value: dayValue, label: dayLabel }) => (
                    <MenuItem key={dayValue} value={dayValue}>
                        {dayLabel}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
});

WeekdaySelect.displayName = 'WeekdaySelect';
export default WeekdaySelect;